{
  "loading": "Loading…",
  "language": {
    "switch": "Interface language"
  },
  "theme": {
    "light": "Light theme",
    "dark": "Dark theme"
  },
  "status": {
    "up": "Up",
    "down": "Down",
    "warn": "Partial",
    "unknown": "Unknown"
  },
  "action": {
    "logout": "Sign out",
    "close": "Close",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "add": "Add",
    "apply": "Apply",
    "retry": "Try again",
    "refresh": "Refresh",
    "copy": "Copy",
    "copied": "Copied",
    "showDetails": "Show details",
    "hideDetails": "Hide details",
    "expand": "Expand",
    "collapse": "Collapse",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "sortBy": "Sort by “{{column}}”"
  },
  "bytes": {
    "b": "{{value, number}} B",
    "kb": "{{value, number}} KB",
    "mb": "{{value, number}} MB",
    "gb": "{{value, number}} GB"
  },
  "ago": {
    "justNow": "just now",
    "seconds_one": "{{count}} s ago",
    "seconds_other": "{{count}} s ago",
    "minutes_one": "{{count}} min ago",
    "minutes_other": "{{count}} min ago",
    "hours_one": "{{count}} h ago",
    "hours_other": "{{count}} h ago",
    "days_one": "{{count}} d ago",
    "days_other": "{{count}} d ago"
  },
  "count": {
    "nodes_one": "{{count}} node",
    "nodes_other": "{{count}} nodes",
    "frames_one": "{{count}} frame",
    "frames_other": "{{count}} frames",
    "checks_one": "{{count}} check",
    "checks_other": "{{count}} checks",
    "permissions_one": "{{count}} permission",
    "permissions_other": "{{count}} permissions",
    "records_one": "{{count}} recording",
    "records_other": "{{count}} recordings"
  },
  "dash": "—",
  "restoringSession": "Restoring the session…",
  "loadingProfile": "Loading the profile…",
  "loadingSection": "Loading the section…"
}
